__turbopack_context__.v({
  "body": "Callout-module__3hqxgW__body",
  "callout": "Callout-module__3hqxgW__callout",
  "info": "Callout-module__3hqxgW__info",
  "success": "Callout-module__3hqxgW__success",
  "tip": "Callout-module__3hqxgW__tip",
  "title": "Callout-module__3hqxgW__title",
  "warning": "Callout-module__3hqxgW__warning",
});
